import React from 'react'
import { RootState, useAppDispatch } from '../../../../redux/store/store';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import TitleModal from '../../../UIcomponents/Modals/TitleModal/TitleModal';
import FormModalEditProduct from './FormModalEditProduct/FormModalEditProduct';
import { resetMarketplaceModalsReducer } from '../../../../redux/slices/components/Marketplace/marketplaceDataSlice';
import { useSelector } from 'react-redux';

const ModalEditProduct = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation();

    const product = useSelector((state: RootState) => state.marketplace.editProductModalData)
  
    const closeModal = () => {
      dispatch(resetMarketplaceModalsReducer())
    }
  
    return (
      <div className="blank-wrapper-modals flex flex-d-column p-relative">
          <button onClick={closeModal} className="p-absolute close-modal-icon pointer">
              <FontAwesomeIcon  icon={solid("times")} className="c-manatee fs-14"/> 
          </button>
          <TitleModal title={t("Marketplace:label_17")} />
          <FormModalEditProduct product={product} /> 
      </div>
    )
}

export default ModalEditProduct